import React from "react"
import SocialsDumpsters from "./socialsDumpsters";

export default function FooterMenuDumpster()
{   
    return(
        <div className="row">
            <div key="fcol1" className="col-lg-4">
                <ul className="footer-list">

                    <div className="collapser">
                        Customers
                    </div>
                    
                    <div className="collapse show">
                        <div key="foot_1_1">                                  
                            <li>
                                <a className="front-link" href="/blog/how-it-works">How Quote Requests Work</a>
                            </li>                                                        
                        </div> 
                        <div key="foot_1_2">                                  
                            <li>
                                <a className="front-link" href="/blog/dumpster-rental-101">Dumpster Rental How-to</a>
                            </li>                                                        
                        </div>
                        <div key="foot_1_3">                                  
                            <li>
                                <a className="front-link" href="/blog/junk-removal-101">Junk Removal How-to</a>
                            </li>                                                        
                        </div> 
                        <div key="foot_1_4">                                  
                            <li>
                                <a className="front-link" href="/blog">Blog</a>
                            </li>                                                        
                        </div>  
                    </div>                                         
                </ul>
            </div>
            <div key="fcol2" className="col-lg-4">
                <ul className="footer-list">

                    <div className="collapser">
                        Pros
                    </div>
                    
                    <div className="collapse show">
                        <div key="foot_2_1">                                  
                            <li>
                                <a className="front-link" href="/pro/guide/dumpster-marketing">Dumpster Rental Marketing</a>
                            </li>                                                        
                        </div>
                        <div key="foot_2_2">                                  
                            <li>
                                <a className="front-link" href="/pro/guide/junk-removal-marketing">Junk Removal Marketing</a>
                            </li>                                                        
                        </div>  
                        <div key="foot_2_3">                                  
                            <li>
                                <a className="front-link" href="/pro/guide/booked-jobs-faq">Booked Jobs FAQ</a>
                            </li>                                                        
                        </div>  
                        <div key="foot_2_4">                                  
                            <li>
                                <a className="front-link" href="/pro/guide">Pro Guide</a>
                            </li>                                                        
                        </div>
                        <div key="foot_2_5">                                  
                            <li>
                                <a className="front-link" href="/pro/guide/tags/success-stories">Success Stories</a>
                            </li>                                                        
                        </div>  
                    </div>                                         
                </ul>
            </div>
            <div key="fcol3" className="col-lg-4">
                <ul className="footer-list">

                    <div className="collapser">
                        Company
                    </div>
                    
                    <div className="collapse show">
                        <div key="foot_3_1">                                  
                            <li>
                                <a className="front-link" href="/about-contact.html">About</a>
                            </li>                                                        
                        </div>
                        <div key="foot_3_2">                                  
                            <li>
                                <a className="front-link" href="/contact.html">Contact Us</a>
                            </li>                                                        
                        </div>
                        <SocialsDumpsters />
                    </div>                                         
                </ul>
            </div>  
        </div>
    )
}